import { create } from 'zustand';

type ToggleProps = {
  defaultEmail?: string;
  infoMessage?: string;
};

interface AuthState {
  defaultEmail: string;
  infoMessage: string;
  loginModalOpen: boolean;
  toggleLoginModal: (options?: ToggleProps) => void;
}

export const useAuthStore = create<AuthState>(
  (set): AuthState => ({
    loginModalOpen: false,
    defaultEmail: '',
    infoMessage: '',
    toggleLoginModal: (options) => {
      const { defaultEmail = '', infoMessage = '' } = options || {};

      set((state) => ({ loginModalOpen: !state.loginModalOpen, defaultEmail, infoMessage }));
    },
  }),
);
